import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery, useNavigate, useParams } from '@common/hooks';
import {
  AppContent,
  ErrorHandler,
  HistoryDropDown,
  LoadingState,
  Icon,
} from '@common/components';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import { WorksListTemplateQuery } from 'works/legacy/graphql/works-list-template';
import ItemTemplateList from './item-template-list';
import { OnboardingListTemplateSummary } from 'works/legacy/components/onboarding-list-template/onboarding-list-template-summary';
import { Alert, Button } from 'antd';
import { BottomActionBar } from './bottom-action-bar';
import { ORGANIZATION_ADMIN_MENU } from 'works/legacy/pages/organization/admin-settings/organization-admin-vertical-nav-menu';
export function OnboardingListsTemplateItemsPage() {
  const { id: worksListTemplateId } = useParams();

  useSetBreadcrumbs([
    {
      name: 'Admin',
      path: '/works/admin',
    },
    {
      name: 'Templates',
      path: '/works/admin/templates',
    },
    {
      name: ORGANIZATION_ADMIN_MENU.TEMPLATES__COMPLIANCE.LABEL,
      path: ORGANIZATION_ADMIN_MENU.TEMPLATES__COMPLIANCE.ROUTE,
    },
    {
      name: 'Items',
      path: `${ORGANIZATION_ADMIN_MENU.TEMPLATES__COMPLIANCE.ROUTE}/${worksListTemplateId}/items`,
    },
  ]);

  const navigate = useNavigate();

  const [isStaged, setIsStaged] = useState(false);

  const { loading, error, data } = useQuery(WorksListTemplateQuery, {
    variables: { id: worksListTemplateId },
  });

  useEffect(() => {
    if (data && data.worksListTemplate.bulkUpdateState === 'pending') {
      setIsStaged(true);
    }
  }, [data]);

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return (
      <ErrorHandler error={error} log="OnboardingListsTemplateItemsPage" />
    );
  }

  const worksListTemplate = data.worksListTemplate;

  const openConfirmUpdatePage = () => {
    navigate(
      `/works/admin/templates/compliance-list/${worksListTemplateId}/items/confirm-updates`
    );
  };

  return (
    <AppContent>
      <OnboardingListTemplateSummary
        worksListTemplate={worksListTemplate}
        showActions
        showDetails
        bottomElements={
          <>
            {isStaged && <StagedAlert onClickAction={openConfirmUpdatePage} />}
            <HistoryDropDown
              data={data.worksListTemplate.history}
              button={true}
            />
          </>
        }
      />
      <ItemTemplateList
        worksListTemplateId={worksListTemplate.id}
        items={worksListTemplate.worksListItemTemplates}
      ></ItemTemplateList>

      <BottomActionBar
        showActionButton={isStaged}
        cancelText="Back"
        actionText="Update Assignments"
        onAction={openConfirmUpdatePage}
        onCancel={() => navigate(-1)}
      />

      <style jsx>{`
        :global(.compliance-bulk-update .ant-modal-content) {
          width: 500px;
        }
        :global(.compliance-bulk-update .ant-modal-confirm-body) {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          align-items: center;
        }
        :global(
          .compliance-bulk-update
            .ant-modal-confirm-body
            .ant-modal-confirm-title
        ) {
          font-weight: bold;
        }
      `}</style>
    </AppContent>
  );
}

OnboardingListsTemplateItemsPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

function StagedAlert({ onClickAction }) {
  return (
    <>
      <Alert
        className="staged-alert"
        showIcon
        icon={<Icon icon="exclamationTriangle" kind="solid" size="sm" />}
        message={
          <>
            Compliance Items not updated on the assignments.
            <Button size="small" type="link" onClick={onClickAction}>
              Update now
            </Button>
          </>
        }
        type="warning"
      />
      <style jsx>{`
        :global(.staged-alert) {
          width: fit-content;
          margin-top: 1em;
        }
      `}</style>
    </>
  );
}

StagedAlert.propTypes = {
  onClickAction: PropTypes.func,
};
